var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoney = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 230,
    viewBox: "0 0 189 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5997_18457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189 195.786H0V229.131H189V195.786Z",
    fill: "#006EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 92.323H0V195.786H189V92.323Z",
    fill: "#6BB6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.805 126.703V161.405C165.449 161.405 154.62 172.234 154.62 185.596H34.3801C34.3801 172.234 23.5515 161.405 10.1953 161.405V126.703C23.5515 126.703 34.3801 115.874 34.3801 102.513H154.62C154.62 115.874 165.449 126.703 178.805 126.703Z",
    fill: "#006EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 206.857H189",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 218.065H189",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5005 162.915C133.488 162.915 165.093 131.31 165.093 92.323C165.093 53.336 133.488 21.7307 94.5005 21.7307C55.5134 21.7307 23.9082 53.336 23.9082 92.323C23.9082 131.31 55.5134 162.915 94.5005 162.915Z",
    fill: "#00EC25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6455 92.323C40.6455 62.5797 64.7568 38.4684 94.5001 38.4684C124.243 38.4684 148.355 62.5797 148.355 92.323",
    fill: "#6BB6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6455 92.323C40.6455 122.066 64.7568 146.178 94.5001 146.178C124.243 146.178 148.355 122.066 148.355 92.323",
    fill: "#006EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1953 92.5096C10.1953 45.9494 47.9399 8.20483 94.5 8.20483",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4043 1.00085L95.6083 8.20484L88.4043 15.4032",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1826 63.3883V121.484",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7696 72.2434H90.8866C84.7004 72.2434 79.6904 76.3487 79.6904 82.5348C79.6904 88.721 84.7061 92.6679 90.8866 92.6679H92.9392",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8 83.4396C108.8 77.2534 103.785 72.2434 97.6042 72.2434H95.1953",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7155 113.036H97.5985C103.785 113.036 108.795 108.931 108.795 102.744C108.795 96.5583 103.779 92.6113 97.5985 92.6113H95.5459",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6846 101.84C79.6846 108.026 84.7002 113.036 90.8807 113.036H93.2896",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.355 92.323C148.355 122.066 124.244 146.178 94.5005 146.178C64.7572 146.178 40.6459 122.066 40.6459 92.323H23.9082C23.9082 131.312 55.5119 162.915 94.5005 162.915C133.489 162.915 165.093 131.312 165.093 92.323H148.355Z",
    fill: "#F0F8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5997_18457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 189,
    height: 229.137,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoney);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Money.b42b96816ea2b7845f467c9a5e41bd3b.svg";